'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CircleProgress = require('./CircleProgress');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CircleProgress).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }